import React, { useEffect, useState, useCallback } from "react";
import AdminNavbar from "../Components/Adminnavbar";
import axios from "axios";
import {
  FaRegCalendarAlt,
  FaUserTie,
  FaBuilding,
  FaPhoneAlt,
  FaChartPie,
  FaWallet,
  FaCopy,
} from "react-icons/fa";
import { useDataContext } from "../Context/dataContext";
import { toast, ToastContainer } from "react-toastify";
import { NotFound } from "./NotFound";
import { useNavigate } from "react-router-dom";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Spinner } from "../Components/Spinner";

function Order() {
  const navigate = useNavigate();
  const { url, infoTkn } = useDataContext();
  const [selectedButton, setSelectedButton] = useState("Usdt");
  const [amountReceived, setAmountReceived] = useState("");
  const [amountReceivedBs, setAmountReceivedBs] = useState("");
  const [currency, setCurrency] = useState("");
  const [amountEuros, setAmountEuros] = useState("");
  const [receipt, setReceipt] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true); // Inicialmente en true

  const copyToClipboard = (address) => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Función para formatear la dirección (mostrar solo inicio y fin)
  const formatWalletAddress = (address) => {
    if (!address) return "Cargando..."; // Si aún no está disponible, muestra un texto temporal
    return `${address.slice(0, 6)}....${address.slice(-4)}`;
  };

  const [currencyBs, setCurrencyBs] = useState([]);

  const fetchCurrencyBs = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/currency-price/1`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setCurrencyBs(response.data.cur_bs);
    } catch (error) {
      console.log(setLoading);
      console.log(error);
    }
  }, [infoTkn, url]);

  const [errors, setErrors] = useState({
    amountEuros: "",
    selectedUser: "",
    receipt: "",
    nameBeneficiary: "",
    idBeneficiary: "",
    accountBeneficiary: "",
    bankBeneficiary: "",
    beneficiary: "",
  });

  // 🟢 Función de validación antes de enviar
  const validateForm = () => {
    let newErrors = {};

    if (!amountEuros) newErrors.amountEuros = "Este campo es obligatorio";
    else if (amountEuros < 30) newErrors.amountEuros = "El mínimo es 30€";

    if (!selectedUser) newErrors.selectedUser = "Selecciona un usuario";
    if (!receipt) newErrors.receipt = "Sube un comprobante";

    if (selectedButton === "Bs") {
      if (!nameBeneficiary ||
        !idBeneficiary ||
        !accountBeneficiary ||
        !bankBeneficiary) newErrors.beneficiary = "Faltan datos del beneficiario.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Retorna true si no hay errores
  };

  // 🟢 Manejador de envío con validaciones
  const handleSendOrder = () => {
    if (validateForm()) {
      sendOrder(); // Solo llama a la función si la validación pasa
    }
  };

  const [nameBeneficiary, setNameBeneficiary] = useState("");
  const [idBeneficiary, setIdBeneficiary] = useState("");
  const [accountBeneficiary, setAccountBeneficiary] = useState("");
  const [bankBeneficiary, setBankBeneficiary] = useState("");

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const fetchDataAdmin = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Auth/findByJWTAdmin/${infoTkn}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setAdmin(response.data.data);

      setUsers(response.data.data.User);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Cambia loading a false después de cargar los datos
    }
  }, [infoTkn, setAdmin, url]);

  const getFormattedDate = () => {
    const options = {
      weekday: "long",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };
    return new Date().toLocaleDateString("es-ES", options);
  };

  const fetchCurrency = async () => {
    try {
      const response = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=eur"
      );
      setCurrency(response.data.tether.eur);
    } catch (error) {
      console.error(error);
    }
  };

  const sendOrder = async () => {
    if (!validateForm()) {
      toast.error("Corrige los errores antes de enviar.");
      return;
    }

    try {
      const data = {
        mov_amount: amountEuros,
        mov_status: "P",
        mov_proof: receipt,
        mov_userId: selectedUser,
        mov_conversionType: selectedButton,
        mov_conversionRate: selectedButton === "Bs" ? currencyBs : currency,
        mov_comment: "comment",
      };

      if (selectedButton === "Bs") {
        data.mov_comment = `${nameBeneficiary}\n${idBeneficiary}\n${accountBeneficiary}\n${bankBeneficiary}`;
      }

      await axios.post(`${url}/Movements/create`, data, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Orden enviada correctamente");
      navigate("/CreateOrder");
    } catch (error) {
      console.error(error);
      toast.error("Error al enviar la orden");
    }
  };

  useEffect(() => {
    fetchCurrency();
    fetchDataAdmin();
    fetchCurrencyBs();
  }, [fetchDataAdmin, fetchCurrencyBs]);

  if (loading) {
    return <Spinner />;
  }

  return admin ? (
    <div className="page-container">
      <AdminNavbar />

      <div className="content-container">
        {/* Sección superior con la fecha y bienvenida */}
        <div className="order-header">
          <div className="order-header__container">
            <div className="order-header__date">
              <FaRegCalendarAlt className="order-header__icon" />
              <span>{getFormattedDate()}</span>
            </div>
            <div className="order-header__welcome">
              <FaUserTie className="order-header__icon" />
              <span>
                Bienvenido, <strong>{admin.adm_user}</strong>
              </span>
            </div>
          </div>
        </div>

        {/* Sección de información de la empresa */}
        <div className="order-info">
          <h3>Detalles Comerciales</h3>
          <div className="order-info__details">
            <div className="order-info__item">
              <FaBuilding className="order-info__icon" />
              <span>
                <strong>Nombre Comercial:</strong> {admin.adm_user}
              </span>
            </div>
            <div className="order-info__item">
              <FaWallet className="order-info__icon" />
              <span>
                <strong>Dirección Wallet:</strong>{" "}
                {formatWalletAddress(admin.adm_wallet)}
                <FaCopy
                  className="wallet-copy-icon"
                  onClick={() => copyToClipboard(admin.adm_wallet)}
                  title="Copiar dirección"
                />
                {copied && (
                  <span className="wallet-copied-text"> ¡Copiada! </span>
                )}{" "}
              </span>
            </div>
            <div className="order-info__item">
              <FaPhoneAlt className="order-info__icon" />
              <span>
                <strong>Contacto:</strong> {admin.adm_name} {admin.adm_lastname}
              </span>
            </div>
            <div className="order-info__item">
              <FaChartPie className="order-info__icon" />
              <span>
                <strong>Porcentaje Manejado:</strong> {admin.adm_porcent}
              </span>
            </div>
          </div>
        </div>

        <div className="date-query Order">
          <div className="date-query__rates">
            {[
              { label: "Tasa USDT Oficial", value: currency },
              {
                label: "Objetiva",
                value: currency * admin.adm_porcent + currency,
              },
              { label: "Tasa Bolívares", value: "1 USDT = Bs. " + currencyBs },
            ].map((rate, index) => (
              <div className="rate" key={index}>
                <div className="rate-label">{rate.label}</div>
                <div className="rate-value">{rate.value}</div>
              </div>
            ))}
          </div>

          {/*Botones de cambio*/}
          <div className="button-group">
            <button
              className={selectedButton === "Bs" ? "selected" : ""}
              onClick={() => setSelectedButton("Bs")}
            >
              Recibir Bs
            </button>
            <button
              className={selectedButton === "Usdt" ? "selected" : ""}
              onClick={() => setSelectedButton("Usdt")}
            >
              Recibir Usdt
            </button>
          </div>

          <div className="tabla-container">
            <table className="usuarios-table">
              <thead>
                <tr>
                  <th>Euros</th>
                  <th>Usuarios</th>
                  <th>Comprobante</th>
                  <th>Usdt Recibidos</th>
                  <th>Beneficiario</th>
                  <th>Estado</th>
                  <th>{selectedButton === "Bs" ? "Comprobante" : "Hash"}</th>
                  {selectedButton === "Bs" && <th>Bs Recibidos</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {/* 🟢 Campo Euros */}
                  <td>
                    <input
                      type="number"
                      placeholder="Euros"
                      value={amountEuros}
                      className="input"
                      onChange={(e) => {
                        setAmountEuros(e.target.value);
                        setErrors({ ...errors, amountEuros: "" }); // Limpiar error al escribir
                        if (selectedButton) {
                          setAmountReceived(
                            (
                              e.target.value /
                              (currency * admin.adm_porcent + currency)
                            ).toFixed(2)
                          );
                          setAmountReceivedBs(
                            (
                              (e.target.value /
                                (currency * admin.adm_porcent + currency)) *
                              currencyBs
                            ).toFixed(2)
                          );
                        }
                      }}
                    />
                    {errors.amountEuros && (
                      <p className="error-text">{errors.amountEuros}</p>
                    )}
                  </td>

                  {/* 🟢 Campo Usuarios */}
                  <td>
                    <select
                      className="input"
                      value={selectedUser}
                      onChange={(e) => {
                        setSelectedUser(e.target.value);
                        setErrors({ ...errors, selectedUser: "" });
                      }}
                    >
                      <option value="">Seleccionar usuario</option>
                      {users
                        .filter((user) => user.use_verif === "S")
                        .map((user) => (
                          <option key={user.use_id} value={user.use_id}>
                            {user.use_name} {user.use_lastName}
                          </option>
                        ))}
                    </select>
                    {errors.selectedUser && (
                      <p className="error-text">{errors.selectedUser}</p>
                    )}
                  </td>

                  {/* 🟢 Campo Comprobante */}
                  <td>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        setReceipt(e.target.files[0]);
                        setErrors({ ...errors, receipt: "" });
                      }}
                      className="input-file"
                    />
                    {errors.receipt && (
                      <p className="error-text">{errors.receipt}</p>
                    )}
                  </td>

                  {/* 🟢 Campo Usdt Recibidos (Calculado) */}
                  <td>
                    <input
                      type="text"
                      value={amountReceived}
                      disabled
                      placeholder="Usdt Recibidos"
                      className="input"
                    />
                  </td>

                  {/* 🟢 Beneficiario (Solo si se selecciona "Bs") */}
                  {selectedButton === "Bs" && (
                    <td>
                      <Button onClick={() => toggle()}>Beneficiario</Button>
                      {errors.beneficiary && (
                      <p className="error-text">{errors.beneficiary}</p>
                    )}
                    </td>
                  )}

                  {/* 🟢 Estado */}
                  <td>
                    <div className="status">
                      <span
                        className="icon"
                        style={{ backgroundColor: "#ffc107" }}
                      ></span>{" "}
                      Pendiente
                    </div>
                  </td>

                  {/* 🟢 Comprobante o Hash */}
                  <td>
                    <div className="status">
                      <span
                        className="icon"
                        style={{ backgroundColor: "#ffc107" }}
                      ></span>{" "}
                      Pendiente
                    </div>
                  </td>

                  {/* 🟢 Bs Recibidos (Solo si se selecciona "Bs") */}
                  {selectedButton === "Bs" && (
                    <td>
                      <input
                        type="text"
                        value={amountReceivedBs}
                        placeholder="Bs Recibidos"
                        className="input"
                      />
                    </td>
                  )}
                </tr>
              </tbody>
            </table>

            {/* 🟢 Modal de Beneficiario */}
            <Modal centered isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle}>Beneficiario</ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label>Nombre y Apellido</Label>
                  <Input
                    type="text"
                    placeholder="Nombre y Apellido"
                    className="input"
                    value={nameBeneficiary}
                    onChange={(e) => {
                      setNameBeneficiary(e.target.value);
                      setErrors({ ...errors, nameBeneficiary: "" });
                    }}
                  />
                  {errors.nameBeneficiary && (
                    <p className="error-text">{errors.nameBeneficiary}</p>
                  )}

                  <Label>Cédula</Label>
                  <Input
                    type="text"
                    placeholder="Cédula"
                    className="input"
                    value={idBeneficiary}
                    onChange={(e) => {
                      setIdBeneficiary(e.target.value);
                      setErrors({ ...errors, idBeneficiary: "" });
                    }}
                  />
                  {errors.idBeneficiary && (
                    <p className="error-text">{errors.idBeneficiary}</p>
                  )}

                  <Label>Número de Cuenta o Teléfono</Label>
                  <Input
                    type="text"
                    placeholder="Número de Cuenta o Teléfono"
                    className="input"
                    value={accountBeneficiary}
                    onChange={(e) => {
                      setAccountBeneficiary(e.target.value);
                      setErrors({ ...errors, accountBeneficiary: "" });
                    }}
                  />
                  {errors.accountBeneficiary && (
                    <p className="error-text">{errors.accountBeneficiary}</p>
                  )}

                  <Label>Banco</Label>
                  <Input
                    type="text"
                    placeholder="Banco"
                    className="input"
                    value={bankBeneficiary}
                    onChange={(e) => {
                      setBankBeneficiary(e.target.value);
                      setErrors({ ...errors, bankBeneficiary: "" });
                    }}
                  />
                  {errors.bankBeneficiary && (
                    <p className="error-text">{errors.bankBeneficiary}</p>
                  )}
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={toggle}>
                  Guardar
                </Button>
              </ModalFooter>
            </Modal>

            {/* 🟢 Botón de Enviar */}
            <div className="date-query__create-order">
              <button onClick={handleSendOrder}>
                {" "}
                {loading ? "Enviando..." : "Enviar"} {/* Texto dinámi co */}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : (
    <NotFound />
  );
}

export { Order };